import { render, staticRenderFns } from "./JobsDelete.vue?vue&type=template&id=1d6b8a9b&scoped=true&"
import script from "./JobsDelete.vue?vue&type=script&lang=js&"
export * from "./JobsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6b8a9b",
  null
  
)

export default component.exports